import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import {
 Box,
 Flex,
 Drawer,
 DrawerBody,
 DrawerHeader,
 DrawerOverlay,
 DrawerContent,
 DrawerCloseButton,
 useDisclosure,
 IconButton,
} from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import Header from '../components/Header/Header.tsx';
import Sidebar from '../components/Sidebar/Sidebar.tsx';
import { useBreakpoint } from '../context/BreakpointContext.tsx';
import PageFooter from '../components/PageFooter/PageFooter.tsx';
import AccountSetupModal from '../modals/AccountSetupModal/AccountSetupModal.tsx';
import { useAuth } from '../context/AuthContext.tsx';

const MainLayout: React.FC = () => {
 const { isOpen, onOpen, onClose } = useDisclosure();
 const { isMobile } = useBreakpoint();
 const { showAccountSetupModal, setShowAccountSetupModal } = useAuth();
 const location = useLocation();

  React.useEffect(() => {
   const handler = (e: MouseEvent) => {
     const target = e.target as HTMLElement;
     const link = target.closest('a[href]') as HTMLAnchorElement | null;
     if (!link) return;
     const href = link.getAttribute('href') || '';
     if (href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
     
     // Check for residents/add page
     if (location.pathname === '/residents/add') {
       e.preventDefault();
       const event = new CustomEvent('attempt-leave-from-add', { detail: href });
       window.dispatchEvent(event);
       return;
     }
     
     // Check for hardware page
     if (location.pathname === '/hardware') {
       e.preventDefault();
       const event = new CustomEvent('attempt-leave-from-hardware', { detail: href });
       window.dispatchEvent(event);
       return;
     }
    };
    document.addEventListener('click', handler, true);
    return () => document.removeEventListener('click', handler, true);
 }, [location.pathname]);

 return (
   <>
     <Flex direction="column" height={isMobile ? 'auto' : '100vh'} minH={"100vh"}>
       <Header isAccountSetupModalOpen={showAccountSetupModal} />

       <Flex flex="1" overflow="hidden">
         {isMobile ? (
           <>
             <IconButton
               icon={<HamburgerIcon fontSize={24} />}
               aria-label="Open menu"
               onClick={onOpen}
               ml="25px"
               mt="18px"
               mr="15px"
               position="absolute"
               top="0"
               zIndex="1401"
             />
             <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
               <DrawerOverlay zIndex={1402}>
                 <DrawerContent>
                   <DrawerCloseButton
                     top="15px"
                     fontSize={18}
                     color="alea.500"
                   />
                   <DrawerHeader bg="#eeeeee">Menu</DrawerHeader>
                   <DrawerBody p="16px" bg="#eeeeee">
                     <Sidebar />
                   </DrawerBody>
                 </DrawerContent>
               </DrawerOverlay>
             </Drawer>
           </>
         ) : (
           <Sidebar />
         )}
         <Box flex="1" mr="25px" ml="25px" overflow="auto">
           <Outlet />
         </Box>
       </Flex>

       <PageFooter />
     </Flex>

     <AccountSetupModal
       isOpen={showAccountSetupModal}
       onClose={() => setShowAccountSetupModal(false)}
     />
   </>
 );
};

export default MainLayout;